var path = 'app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/alarmBasedSummary.template.html';
var html = "<alarm-based-summary\n  policy=\"$ctrl.policy\"\n  server-group=\"$ctrl.serverGroup\"\n  application=\"$ctrl.application\"\n></alarm-based-summary>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;